// src/components/ProtectedRoute.js — session-based guard
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { fetchMe } from '../lib/api';

function normalizeUser(me) {
  // /api/me -> { ok, user }  OR  /api/users/me -> user
  return me && typeof me === 'object' && 'user' in me ? me.user : me;
}

export function ProtectedRoute({ children }) {
  const [state, setState] = useState({ loading: true, authed: false });

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const me = await fetchMe();
        if (!mounted) return;

        const user = normalizeUser(me);        if (user) try { localStorage.setItem('user', JSON.stringify(user)); } catch {}
        sessionStorage.setItem('user', JSON.stringify(user));

        setState({ loading: false, authed: !!user });

        // Notify App.js to refresh its user state (so BottomNav shows immediately)
        try { window.dispatchEvent(new Event('auth-changed')); } catch {}
      } catch {
        if (!mounted) return;
        setState({ loading: false, authed: false });
      }
    })();
    return () => { mounted = false; };
  }, []);

  if (state.loading) return <div style={{ padding: 16 }}>Checking session…</div>;
  return state.authed ? children : <Navigate to="/login" replace />;
}

export function OrganiserRoute({ children }) {
  const [state, setState] = useState({ loading: true, authed: false });

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const me = await fetchMe();
        if (!mounted) return;

        const user = normalizeUser(me);        if (user) try { localStorage.setItem('user', JSON.stringify(user)); } catch {}
        sessionStorage.setItem('user', JSON.stringify(user));

        const ok = !!(user && (user.is_organiser || user.role === 'organiser') && user.is_approved !== false);
        setState({ loading: false, authed: ok });
      } catch {
        if (!mounted) return;
        setState({ loading: false, authed: false });
      }
    })();
    return () => { mounted = false; };
  }, []);

  if (state.loading) return <div style={{ padding: 16 }}>Checking access…</div>;
  return state.authed ? children : <Navigate to="/" replace />;
}
